import {Vector2} from 'three';

import * as corgi from 'external/dev_april_corgi+/js/corgi';
import {EmptyDeps} from 'external/dev_april_corgi+/js/corgi/deps';
import {Service} from 'external/dev_april_corgi+/js/corgi/service';

import {Args, Divider, Menu, MenuItem} from './menu_controller';
import {MenuElement} from './menu_element';

export class MenuService extends Service<EmptyDeps> {
  open(
    context: Args,
    items: Array<Divider | Menu | MenuItem>,
    position: Vector2,
    parent: Element,
    options?: {
      accent?: number[];
      anchor?: 'first_item' | 'top_left';
    },
  ): void {
    const bound = parent.getBoundingClientRect();
    corgi.appendElement(
      parent,
      <MenuElement
        accent={options?.accent ?? []}
        anchor={options?.anchor ?? 'first_item'}
        bound={bound}
        context={context}
        items={items}
        position={position}
      />,
    );
  }
}
